import { jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { styled } from 'styled-components';
import { StyledInputContainer } from './StyledInputContainer.js';
const InputWithIconsContainer = styled.div `
  display: flex;
  align-items: flex-end;
  gap: 8px;

  ${StyledInputContainer} {
    flex: 1;
  }
`;
export const InputIconsRenderer = memo(function InputIconsRenderer({ children, iconEnd, iconStart }) {
    if (iconStart || iconEnd) {
        return (_jsxs(InputWithIconsContainer, { children: [!!iconStart && iconStart, children, !!iconEnd && iconEnd] }));
    }
    return children;
});
